export const USER_ROLES = {
  ADMIN: "admin",
  SUPER_ADMIN: "super-admin",
  MODERATOR: "moderator",
  MDM: "mdm",
  EDITOR: "editor",
  USER_ADMIN: "user-admin"
};
